import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import debounce from "lodash.debounce";
import api from "service/api";
import ModalPipelineLibraryConfiguration from "components/Modal/ModalPipelineLibraryConfiguration";
import { useFormContext } from "react-hook-form";

const CustomTag = ({
  data,
  removeProps,
  setDisplay,
  setSelectedOptionForModal,
  configuration,
  isConfigured,
}) => {
  const { setValue, getValues } = useFormContext();
  return (
    <div
      onClick={() => {
        setSelectedOptionForModal({ ...data, ...configuration });
        setDisplay(true);
      }}
      style={{
        cursor: "pointer",
        padding: "2px 0 2px 8px",
        backgroundColor: isConfigured ? "#e2fee2" : "#e1e1e1",
        display: "inline-flex",
        alignItems: "center",
        margin: "4px",
        fontSize: "12px",
        borderRadius: "4px",
        border: isConfigured ? "1px solid green" : "none",
      }}
    >
      {data.label}
      <button
        onClick={(e) => {
          e.stopPropagation();
          const updatedValue = getValues("libraries").filter(
            (option) => option.value !== data.value,
          );
          setValue("libraries", updatedValue);
          removeProps.onClick();
        }}
        style={{
          marginLeft: "6px",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          color: "#888",
          fontSize: "14px",
          transition: "color 0.2s",
        }}
        onMouseEnter={(e) => (e.target.style.color = "#333")}
        onMouseLeave={(e) => (e.target.style.color = "#888")}
      >
        ×
      </button>
    </div>
  );
};

const LibrariesSelect = ({ client, onChange, value, setValue, getValues }) => {
  const { clearErrors } = useFormContext();
  const [options, setOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const fetchOptions = debounce(async (inputValue, callback) => {
    try {
      const response = await api.get(
        `/libraries/autocomplete/pipeline?search=${inputValue}&clientId=${client}`,
      );

      const fetchedOptions = response.data.map((item) => ({
        value: item.id,
        label: item.title,
      }));

      setOptions(fetchedOptions);
      callback(fetchedOptions);
    } catch (error) {
      console.error("Error fetching options:", error);
      callback([]);
    }
  }, 300);

  const handleModalClose = (updatedData) => {
    const current = getValues("libraryConfigurations") || {};
    setValue("libraryConfigurations", {
      ...current,
      [selectedOption.value]: updatedData,
    });
    clearErrors("libraryConfigurations");
    setIsModalOpen(false);
  };

  return (
    <>
      <AsyncSelect
        isMulti
        cacheOptions
        loadOptions={(input, cb) => {
          if (input.startsWith("@")) {
            input = input.substring(1);
          }

          if (!input.trim() || input.length < 2) {
            cb([]);
            return;
          }

          fetchOptions(input, cb);
        }}
        placeholder="Pesquisar biblioteca (Digite 2 caracteres ou mais)..."
        onChange={(sel) => {
          const libs = sel || [];
          setValue("libraries", libs);
          clearErrors(["libraries", "libraryConfigurations"]);
          onChange(libs);
        }}
        value={value}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({ ...base, minHeight: "40px" }), // Optional for consistent UI
        }}
        noOptionsMessage={() => "Nenhuma biblioteca encontrada."}
        loadingMessage={() => "Pesquisando..."}
        components={{
          MultiValue: (props) => {
            const configurations = getValues("libraryConfigurations") || {};
            return (
              <CustomTag
                {...props}
                setDisplay={setIsModalOpen}
                setSelectedOptionForModal={setSelectedOption}
                configuration={configurations[props.data.value]}
                isConfigured={!!configurations[props.data.value]}
              />
            );
          },
        }}
      />
      {isModalOpen && selectedOption && (
        <ModalPipelineLibraryConfiguration
          toggle={isModalOpen}
          setToggle={setIsModalOpen}
          onSave={handleModalClose}
          option={selectedOption}
        />
      )}
    </>
  );
};

export default LibrariesSelect;
